/*
 * Bewusst eine eigene, abhängigkeitsfreie Datei: die Kontaktansicht und das
 * Kundentagebuch bauen damit ihre Links, ohne das Notizfeld mitzuladen.
 */
/**
 * Der Link in die Vorgangsansicht mit Sprungmarke — Gegenstück zu
 * `vorgangMitteilungsLink` im Backend. Für Kontaktansicht und Kundentagebuch:
 * Klick auf ein To-do öffnet den Vorgang MIT aufgeklapptem To-do.
 */
export function vorgangSprungLink(
    vorgangId: number,
    opts?: { todoId?: number | null; notiz?: { quelle: "vorgang" | "todo"; id: number } | null },
): string {
    const teile: string[] = [];
    const t = opts?.todoId;
    if (t != null && Number.isInteger(t) && t > 0) teile.push(`todo=${t}`);
    const n = opts?.notiz;
    if (n && Number.isInteger(n.id) && n.id > 0) teile.push(`notiz=${n.quelle}:${n.id}`);
    return teile.length ? `/vorgaenge/${vorgangId}?${teile.join("&")}` : `/vorgaenge/${vorgangId}`;
}
